// BarWidget.tsx

import React from 'react';
import { KPIConfig } from '../../config/pageConfig';
import { ArrowUpOutlined } from '@ant-design/icons';

interface BarWidgetProps {
  config: KPIConfig;
}

// Helper function to format INR
const formatCurrency = (value: number | undefined): string => {
  if (value === undefined) return '';
  // Formats to 10,000,000 ₹ (or similar)
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value).replace('₹', '₹ '); // Add space for better alignment
};

const BarWidget: React.FC<BarWidgetProps> = ({ config }) => {
  const percentage = config.target ? Math.round((config.achieved! / config.target) * 100) : 0;

  return (
    <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
      <h3 className="text-lg font-bold text-gray-700 mb-1">{config.title}</h3>

      {/* Target and Achieved Numbers */}
      <div className="flex justify-between mb-2">
        <span className="text-md font-bold text-gray-800">{formatCurrency(config.target)}</span>
        <span className="text-md font-bold text-gray-800">{formatCurrency(config.achieved)}</span>
      </div>

      {/* Progress Bar (Manual Tailwind Implementation for flexibility) */}
      <div className="relative h-2 bg-gray-200 rounded-full mb-2">
        <div
          className="absolute h-2 rounded-full"
          style={{ width: `${percentage}%`, backgroundColor: config.color }}
          title={`${percentage}% Achieved`}
        ></div>
      </div>
      
      {/* Target/Achieved Labels and Percentage Change */}
      <div className="flex justify-between text-xs text-gray-500 mb-4">
        <span>Target</span>
        <span className='font-semibold'>Achieved</span>
      </div>

      <div className="flex items-center justify-end text-sm font-medium text-green-600">
        <ArrowUpOutlined className="mr-1" />
        {config.percentageChange}%
      </div>
    </div>
  );
};

export default BarWidget;